import { render, staticRenderFns } from "./AddRouter.vue?vue&type=template&id=3036bad5&scoped=true&"
import script from "./AddRouter.vue?vue&type=script&lang=js&"
export * from "./AddRouter.vue?vue&type=script&lang=js&"
import style0 from "./AddRouter.vue?vue&type=style&index=0&id=3036bad5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036bad5",
  null
  
)

export default component.exports